import script from "./PasswordInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordInput.vue?vue&type=script&setup=true&lang=js"

import "./PasswordInput.vue?vue&type=style&index=0&id=2061cf1b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2061cf1b"]])

export default __exports__